
<div class="hr-layout">
  <app-hygine-sidebar></app-hygine-sidebar>
  <div class="hr-main-content">
    <div class="hr-report-panel" >
    <div class="hr-page-outer">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="hr-page-wrap">
            <div class="hr-header-row">
            <div class="hr-header-top">
              <div class="hr-header-title-group">
                <h1 class="hr-main-title">Hygiene  Live Update</h1>
                <span class="hr-active-combo-label">{{ activeSlideLabel }}</span>
              </div>
              <div class="hr-cards-row" *ngIf="isComboSlide(slides[activeSlide])">
                <div class="hr-summary-card hr-card-purple" [class.hr-card-active]="isDateTabActive('today', activeSlide)"
                  (click)="selectDateTab('today')" role="button" tabindex="0">
                  <div class="hr-summary-text">
                    <span class="hr-summary-label">Today's Photo</span>
                    <span class="hr-summary-value">{{ summaryCount('today') }}</span>
                  </div>
                </div>
                <div class="hr-summary-card hr-card-orange" [class.hr-card-active]="isDateTabActive('yesterday', activeSlide)"
                  (click)="selectDateTab('yesterday')" role="button" tabindex="0">
                  <div class="hr-summary-text">
                    <span class="hr-summary-label">Yesterday's Photo</span>
                    <span class="hr-summary-value">{{ summaryCount('yesterday') }}</span>
                  </div>
                </div>
                <div class="hr-summary-card hr-card-green" [class.hr-card-active]="isDateTabActive('last7', activeSlide)"
                  (click)="selectDateTab('last7')" role="button" tabindex="0">
                  <div class="hr-summary-text">
                    <span class="hr-summary-label">Last 7 day's</span>
                    <span class="hr-summary-value">{{ summaryCount('last7') }}</span>
                  </div>
                </div>
                <div class="hr-summary-card hr-card-red" [class.hr-card-active]="isDateTabActive('month', activeSlide)"
                  (click)="selectDateTab('month')" role="button" tabindex="0">
                  <div class="hr-summary-text">
                    <span class="hr-summary-label">This Month</span>
                    <span class="hr-summary-value">{{ summaryCount('month') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Combined carousel: summary data + pictures per combination -->
          <div class="hr-summary-carousel-wrap" (mouseenter)="pauseCarousel()" (mouseleave)="resumeCarousel()">
            <div class="hr-summary-carousel">
              <div class="hr-combo-viewport">
                <button type="button" class="hr-combo-arrow hr-combo-prev" (click)="prevSlide()" aria-label="Previous combination">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <button type="button" class="hr-combo-arrow hr-combo-next" (click)="nextSlide()" aria-label="Next combination">
                  <i class="fa fa-chevron-right"></i>
                </button>
                <div class="hr-combo-track" [style.transform]="'translateX(-' + (activeSlide * 100) + '%)'">
                  <div class="hr-summary-slide" *ngFor="let s of slides; let i = index">
                    <ng-container *ngIf="isComboSlide(s)">
                    <div class="hr-main-card">
                      <h2 class="hr-content-heading">{{ s.label }} — Pictures ({{ picturesOf(s).length }})</h2>
                      <div class="hr-pictures-grid">
                        <div class="hr-pic-card" *ngFor="let p of picturesOf(s)" (click)="openImageDialog(p)">
                          <div class="hr-pic-placeholder">
                            <img *ngIf="p.fileName" [src]="p.fileName" [alt]="p.departmentName" class="hr-pic-img"
                              (error)="onImageError(p.imageRefId)">
                            <i *ngIf="!p.fileName || imageErrorIds.has(p.imageRefId)" class="fa fa-image"></i>
                          </div>
                          <div *ngIf="p.campusName || p.buildingName" class="hr-pic-campus-below">
                            <span class="hr-pic-campus-text">{{ (p.campusName || '') + (p.campusName && p.buildingName ? ' · ' : '') + (p.buildingName || '') }}</span>
                            <span *ngIf="p.latitude != null && p.longitude != null" class="hr-pic-map-icon-wrap" (mousedown)="onMapIconClick($event, p.latitude, p.longitude)" (click)="$event.stopPropagation(); $event.preventDefault()" role="button" tabindex="0" (keydown.enter)="onMapIconClick($event, p.latitude, p.longitude)">
                              <img [src]="mapIconPath" alt="Map" class="hr-pic-location-icon hr-pic-location-clickable">
                            </span>
                          </div>
                          <div class="hr-pic-employee-below" *ngIf="(p.employeeName || p.designation || p.mobileNo) || (p.staffDetails?.[0]?.employeeName || p.staffDetails?.[0]?.staffName || p.staffDetails?.[0]?.designation || p.staffDetails?.[0]?.mobileNo)">
                            <span *ngIf="p.employeeName || p.staffDetails?.[0]?.employeeName || p.staffDetails?.[0]?.staffName" class="hr-pic-employee-line">{{ p.employeeName || p.staffDetails?.[0]?.employeeName || p.staffDetails?.[0]?.staffName }}</span>
                            <span *ngIf="p.designation || p.staffDetails?.[0]?.designation" class="hr-pic-employee-line">{{ p.designation || p.staffDetails?.[0]?.designation }}</span>
                            <span *ngIf="p.mobileNo || p.staffDetails?.[0]?.mobileNo" class="hr-pic-employee-line">{{ p.mobileNo || p.staffDetails?.[0]?.mobileNo }}</span>
                          </div>
                          <div class="hr-pic-info">
                            <div class="hr-pic-dept-row">
                              <span class="hr-pic-dept">{{ p.activityName || p.departmentName }}</span>
                              <span class="hr-pic-staff" *ngIf="p.employeeCount != null">{{ p.employeeCount }} staff</span>
                            </div>
                            <div class="hr-pic-meta">
                              <span class="hr-pic-datetime">{{ getPictureDateTime(p) }}</span>
                            </div>
                          </div>
                        </div>
                        <p *ngIf="s.report && picturesOf(s).length === 0" class="hr-no-pictures">No pictures found.</p>
                      </div>
                    </div>
                    </ng-container>

                    <ng-container *ngIf="isMapSlide(s)">
                      <div class="hr-main-card hr-map-slide">
                        <h2 class="hr-content-heading">{{ s.label }} — Locations ({{ mapMarkers.length }})</h2>
                        <google-map
                          *ngIf="activeSlide === i"
                          class="hr-google-map"
                          height="520px"
                          width="100%"
                          [center]="mapCenter"
                          [zoom]="mapZoom">
                          <map-marker
                            *ngFor="let m of mapMarkers"
                            [position]="m.position"
                            [title]="m.title"
                            [options]="m.options">
                          </map-marker>
                        </google-map>
                        <p *ngIf="mapMarkers.length === 0" class="hr-no-pictures hr-map-empty">
                          No building locations found for the selected date range.
                        </p>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <div class="hr-combo-dots">
              <button *ngFor="let s of slides; let i = index" type="button" class="hr-combo-dot"
                [class.hr-combo-dot-active]="i === activeSlide" (click)="goToSlide(i)" [attr.aria-label]="s.label"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    </div>
  </div>
  </div>
</div>
<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
